module.exports = __webpack_public_path__ + "img/hero@2x.a9b43c28.jpg";